import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

export const useStyles = makeStyles((theme: Theme) => ({
    '@global': {
        '.modal.MuiDialog-root': {
            '& .MuiDialog-paper': {
                backgroundColor: 'transparent !important',
                boxShadow: 'none !important',
                margin: '12px !important',
                borderRadius: '24px !important', 
                overflow: 'hidden', 
                backgroundClip: 'padding-box', 
                position: 'relative',
                '@media (max-width: 766px)': {
                    top: '8%',
                    margin: '0 !important',
                    maxWidth: '100% !important',
                    width: '100% !important',
                    height: '100% !important',
                    maxHeight: '100% !important',
                    borderRadius: '0 !important',
                },
                '@media (min-width: 768px) and (max-width: 907px)': {
                    top: '8%',
                    margin: '0 !important',
                    maxWidth: '100% !important',
                    width: '100% !important',
                    height: '100% !important',
                    maxHeight: '100% !important',
                    borderRadius: '24px !important',
                },
                [theme.breakpoints.down('sm')]: {
                    top: '6%',
                    margin: '0 !important',
                    maxWidth: '100% !important',
                    width: '100% !important',
                    height: '100% !important',
                    maxHeight: '100% !important',
                    borderRadius: '24px !important',
                }
            },
            '& .MuiBackdrop-root': {
                backgroundColor: 'rgba(0, 0, 0, 0.8) !important',
                '@media (max-width: 766px)': {
                    backgroundColor: 'rgba(0, 0, 0, 0.1) !important',
                },
                '@media (min-width: 768px) and (max-width: 907px)': {
                    backgroundColor: 'rgba(0, 0, 0, 0.2) !important',
                },
                [theme.breakpoints.down('sm')]: {
                    backgroundColor: 'rgba(0, 0, 0, 0.1) !important',
                }
            }
        }
    },

    modalContent: {
        background: 'rgba(245, 245, 245, 0.05)',
        borderRadius: '24px', 
        overflow: 'hidden',
        backdropFilter: 'blur(32px)',
        width: '100%',
        minWidth: 840,
        padding: 24,
        '&.MuiDialog-paper': {
            background: 'transparent !important',
        },
        '& .MuiPaper-root': {
            background: 'transparent',
        },
        '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(245, 245, 245, 0.05)',
        },
        '& .MuiDialogContent-root': {
            background: 'rgba(245, 245, 245, 0.05)',
            padding: '0',
        },
        '@media (max-width: 766px)': {
            width: '100%',
            height: '100vh',
            minWidth: 'auto',
            maxWidth: '100%',
            padding: '5px 12px',
            borderRadius: 0,
            background: 'rgba(18, 18, 18, 0.9)',
        },
        '@media (min-width: 768px) and (max-width: 907px)': {
            width: '100%',
            height: '100vh', 
            minWidth: 'auto',
            maxWidth: '100%',
            padding: '10px 20px',
            borderRadius: 10,
            background: 'rgba(20, 20, 20, 0.9)',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            height: '100vh',
            minWidth: 'auto',
            maxWidth: '100%',
            padding: '5px 12px',
            borderRadius: 0,
            background: 'rgba(18, 18, 18, 0.9)',
        }
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '8px',
        marginBottom: 15,
        '& svg': {
            color: '#fff',
        },
        '@media (max-width: 766px)': {
            marginBottom: 10,
        },
    },
    statsBlock: {
        display: 'flex',
        gap: 40,
        '@media (max-width: 766px)': {
            flexDirection: 'column',
            gap: 20,
        },
        [theme.breakpoints.between('sm', 'md')]: {
            flexDirection: 'column',
            gap: 10,
            alignItems: 'center',
        },
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: 15,
        }
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        gap: 5,
        fontSize: 18,
        fontWeight: 300,
        color: '#F5F5F5',
        '& span': {
            fontWeight: 700,
        }
    },
    closeButton: {
        background: 'none',
        border: 'none',
        padding: '8px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 0.7,
        transition: 'opacity 0.2s',
        '&:hover': {
            opacity: 1
        },
        '& img': {
            width: '16px',
            height: '16px'
        }
    },
    contentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        [theme.breakpoints.down('sm')]: {
            overflowY: 'scroll',
            maxHeight: 'calc(100vh - 100px)',
            scrollbarWidth: 'none',
            '-ms-overflow-style': 'none',
            '&::-webkit-scrollbar': {
                display: 'none',
            },
        },
    },
    separator: {
        width: '100%',
        height: '1px',
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        margin: '20px 0',
        '@media (max-width: 766px)': {
            margin: '10px 0',
        },
        [theme.breakpoints.down('sm')]: {
            margin: '10px 0',
        }
    },
    gameModeGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 8,
        '@media (max-width: 766px)': {
            display: 'flex',
            marginBottom: '0',
            justifyContent: 'space-between',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            marginBottom: '0',
            justifyContent: 'space-between',
        }
    },
    gameModeCard: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        padding: 24,
        borderRadius: 16,
        backgroundColor: 'rgba(245, 245, 245, 0.05)',
        '@media (max-width: 766px)': {
            backgroundColor: 'transparent',
            padding: 5,
        },
        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'transparent',
            padding: 5,
        }
    },
    cardHeader: {

    },
    cardTitle: {
        fontSize: 18,
        fontWeight: 600,
        color: '#fff',
        marginBottom: '4px',
        '@media (max-width: 766px)': {
            fontSize: 16,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: 16,
        }
    },
    gamesPlayed: {
        fontSize: 18,
        color: '#BDBDBD',
        fontWeight: 300,
        '& span': {
            fontWeight: 600,
            color: '#fff',
        },
        '@media (max-width: 766px)': {
            fontSize: 16,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: 16,
        }
    },
    circularProgressWrapper: {
        width: '180px',
        height: '180px',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        '@media (max-width: 766px)': {
            width: '32vw',
            height: '32vw',
            marginTop: '1vw',
        },
        [theme.breakpoints.down("sm")]: {
            width: '40vw',
            height: '40vw',
            marginTop: '2vw',
        }
    },
    progressStats: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        '@media (max-width: 766px)': {
            fontSize: '4vw',
            gap: '3vw',
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: '4vw',
            gap: '3vw',
        }
    },
    winsText: {
        color: '#00BA6C',
        fontSize: 18,
        fontWeight: 500,
        '& span': {
            fontWeight: 700,
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: 15,

        }

    },
    lossesText: {
        color: '#FF1C29',
        fontSize: 18,
        fontWeight: 500,
        '& span': {
            fontWeight: 700,
        },
                [theme.breakpoints.down("sm")]: {
            fontSize: 15,

        }
    },
    labelsContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 16,
        marginTop: 8,
        '@media (max-width: 766px)': {
            flexDirection: 'column',
            alignItems: 'center',
            gap: 5,
            marginTop: 0,
        },
        '@media (min-width: 768px) and (max-width: 907px)': {
            flexDirection: 'row',
            alignItems: 'center',
            gap: 10,
            marginTop: 0,
        },
        [theme.breakpoints.down("sm")]: {
            flexDirection: 'column',
            alignItems: 'center',
            gap: 5,
        }
    },
    labelItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 18,
        color: '#FFFFFF',
        '@media (max-width: 766px)': {
            fontSize: 15,
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: 15,
        }
    },
    placeholderCircle: {
        width: 9,
        height: 9,
        borderRadius: '50%',
        backgroundColor: '#00BA6C'
    },
    placeholderCircleLoss: {
        width: 9,
        height: 9,
        borderRadius: '50%',
        backgroundColor: '#FF1C29'
    },   
    statsGrid: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        width: '100%',
        '@media (max-width: 766px)': {
            gap: 8,
            maxWidth: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            gap: 8,
            maxWidth: '100%', 
        }
    },
    mobileStatsGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        borderRadius: '12px',
        padding: '2px',
        width: '100%', 
        maxWidth: '100%', 
        [theme.breakpoints.down('sm')]: {
            marginBottom: '1vw',
        }
    },
    totalGamesCard: {
        backgroundColor: '#1A1D1E',
        borderRadius: 10,
        padding: 16,
        textAlign: 'center',
        width: '100%', 
        maxWidth: '100%', 
    },
    statsRow: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 8,
        width: '100%'
    },
    statsPairRow: {
        display: 'flex',
        gap: 8,
        width: '100%',
        '& > div': {
            flex: 1,
            background: '#1A1D1E',
            borderRadius: 10,
            minWidth: 0,
        },        
    },
    statsCard: {
        flex: 1,
        backgroundColor: 'rgba(245, 245, 245, 0.05)',
        borderRadius: '8px',
        padding: '32px 16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        textAlign: 'center',
        '@media (max-width: 766px)': {
            padding: '15px',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '12px',
        }
    },
    statsLabel: {
        fontSize: 16,
        fontWeight: 300,
        color: 'rgba(245, 245, 245, 0.8)',
        textTransform: 'uppercase',
        marginBottom: '4px',
        '@media (max-width: 766px)': {
            fontSize: 12,
            letterSpacing: '0.5px'
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: 12,
            letterSpacing: '0.5px'
        }
    },
    statsValue: {
        fontSize: 20,
        fontWeight: 600,
        color: '#fff',
        '@media (max-width: 766px)': {
            fontSize: 18
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: 18
        }
    },
    statsValueGreen: {
        color: '#00BA6C',
        fontWeight: 600,
        fontSize: 20,
        '@media (max-width: 766px)': {
            fontSize: 18
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: 18
        }
    },
    statsValueRed: {
        color: '#FF1C29',
        fontWeight: 600,
        fontSize: 20,
        '@media (max-width: 766px)': {
            fontSize: 18
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: 18
        }
    },
    streaksGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '2px',
        background: 'rgba(40, 44, 46, 0.4)',
        borderRadius: '12px',
        padding: '2px',
    },
    streakCard: {
        padding: '16px',
        background: 'rgb(26, 29, 30)',
    },
    streakLabel: {
        fontSize: '12px',
        color: 'rgba(255, 255, 255, 0.45)',
        textTransform: 'uppercase',
        marginBottom: '4px',
    },
    streakValue: {
        fontSize: '20px',
        fontWeight: 600,
        color: '#fff',
        '&.green': {
            color: '#00BA6C',
        },
        '&.red': {
            color: '#FF1C29',
        }
    },
}));

export const circularProgressStyles = {
    pathColor: "#00BA6C",
    trailColor: "#FF1C29",
    pathTransitionDuration: 0.5,
    backgroundColor: 'transparent',
    rotation: 0.75,
    strokeLinecap: 'round',
    textSize: '16px',
};